import * as React from 'react';
import * as moment from 'moment';
import config from '@/server/config';
import request from '@/server/request';
import { parse } from 'query-string';

export default class NotificationDetail extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: parse(this.props.location.search).id || '',
            data: {}, // 页面数据
        }
    }

    public componentDidMount() { 
        this.getData();
        this.setRead();
    }

    public render() {
        return (
            <div className="notification-detail">
                <h5>{this.state.data.articleName}</h5>
                <p className="notification-dtime">{this.state.data.releaseTime ? moment(this.state.data.releaseTime).format('YYYY-MM-DD HH:mm:ss') : ''}</p>
                <div className="notification-summary">{this.state.data.articleSummary}</div>
                <div className="notification-dcontent" dangerouslySetInnerHTML={{ __html: this.state.data.articleContent }}></div>
            </div>
        )
    }

    // 获取页面数据
    private async getData() { 
        const r = await request({
            url: `${config.API}member/wap/article/detail?articleId=${this.state.id}`
        });
        if (r.code === 1) { 
            this.setState({
                data: r.obj
            });
        }
    }

    // 标记页面为已读
    private async setRead() { 
        request({
            url: `${config.API}member/wap/save/memberLog?articleId=${this.state.id}`
        });
    }
}